import { render, staticRenderFns } from "./resourceSharing.vue?vue&type=template&id=0adfa229&scoped=true&"
import script from "./resourceSharing.vue?vue&type=script&lang=js&"
export * from "./resourceSharing.vue?vue&type=script&lang=js&"
import style0 from "./resourceSharing.vue?vue&type=style&index=0&id=0adfa229&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adfa229",
  null
  
)

export default component.exports